import { DeliveryEstimate } from "@redotech/redo-conversion-core-common/conversion/conversion-autocheck";
import {
  DeliveryEstimatePortal,
  useDeliveryEstimatePortals,
} from "./use-delivery-estimate-portals";

export const PRODUCT_PAGE_DELIVERY_ESTIMATE_CONTAINER_ID =
  "redo-delivery-estimate-container";

export function useRenderPdps({
  deliveryEstimate,
}: {
  deliveryEstimate: DeliveryEstimate;
}): DeliveryEstimatePortal[] {
  return useDeliveryEstimatePortals({
    selectorConfigs: deliveryEstimate.pdpSelectors,
    containerId: PRODUCT_PAGE_DELIVERY_ESTIMATE_CONTAINER_ID,
  });
}
